interface PaginationProps {
  page: number
  totalPages: number
  total: number
  limit: number
  onPageChange: (page: number) => void
}

export function Pagination({ page, totalPages, total, limit, onPageChange }: PaginationProps) {
  const start = (page - 1) * limit + 1
  const end = Math.min(page * limit, total)

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-compumaq-dourado/25 bg-compumaq-pretoSuave">
      <p className="text-sm text-compumaq-textoSuave">
        Mostrando {start}–{end} de {total} registro(s)
      </p>
      <div className="flex gap-1">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="px-3 py-1.5 text-sm border border-compumaq-dourado/25 text-compumaq-texto rounded-lg disabled:opacity-40 hover:bg-compumaq-preto transition-colors"
        >
          Anterior
        </button>
        <span className="px-3 py-1.5 text-sm text-compumaq-textoSuave">
          {page} / {totalPages}
        </span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="px-3 py-1.5 text-sm border border-compumaq-dourado/25 text-compumaq-texto rounded-lg disabled:opacity-40 hover:bg-compumaq-preto transition-colors"
        >
          Proximo
        </button>
      </div>
    </div>
  )
}
